var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotCurrentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 2,
    viewBox: "0 0 24 24",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    height: "1em",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.685 10.661c-.3 -.6 -.795 -1.086 -1.402 -1.374m-3.397 .584a3 3 0 1 0 4.24 4.245"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.357 6.33a8 8 0 1 0 11.301 11.326m1.642 -2.378a8 8 0 0 0 -10.597 -10.569"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2v2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20v2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20 12h2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12h2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3 3l18 18"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotCurrentIcon);
export default __webpack_public_path__ + "static/media/NotCurrentIcon.d61b25dca612ef5f859c6f0205c4fa2e.svg";
export { ForwardRef as ReactComponent };